import { useState } from 'react';
import { Link } from 'react-router-dom';
import { dramas } from '@/mocks/dramas';

export default function SearchPage() {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState(dramas);
  const [searched, setSearched] = useState(false);

  const handleSearch = () => {
    const q = query.trim();
    if (!q) {
      setResults(dramas);
    } else {
      setResults(
        dramas.filter(
          (d) =>
            d.name.toLowerCase().includes(q.toLowerCase()) ||
            d.genre.includes(q) ||
            d.region.includes(q)
        )
      );
    }
    setSearched(true);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') handleSearch();
  };

  return (
    <div className="min-h-screen bg-background-50">
      <header className="fixed top-0 left-0 right-0 z-50 bg-background-50/95 backdrop-blur-md border-b border-background-200">
        <div className="w-full px-4 md:px-6">
          <div className="flex items-center justify-between h-[72px] max-w-[1400px] mx-auto">
            <Link to="/" className="flex items-center gap-2 text-foreground-950 no-underline cursor-pointer">
              <span className="w-9 h-9 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg font-heading text-lg">努</span>
              <span className="text-xl font-heading font-bold whitespace-nowrap">努努影院</span>
            </Link>
            <div className="flex items-center gap-3">
              <Link to="/category" className="text-sm text-foreground-600 hover:text-primary-500 cursor-pointer">分类浏览</Link>
              <Link to="/search" className="text-sm text-primary-500 font-medium cursor-pointer">搜索</Link>
            </div>
          </div>
        </div>
      </header>

      <div className="pt-[72px]">
        <div className="w-full px-4 md:px-6 max-w-[1200px] mx-auto py-8">
          <div className="max-w-[640px] mx-auto mb-10">
            <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-6">搜索电视剧</h1>
            <div className="flex gap-2">
              <div className="flex-1 relative">
                <input
                  type="text"
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                  onKeyDown={handleKeyDown}
                  placeholder="输入剧名、类型或地区..."
                  className="w-full px-4 py-3 pl-10 bg-background-100 border border-background-200 rounded-full text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300"
                />
                <i className="ri-search-line absolute left-3.5 top-1/2 -translate-y-1/2 text-foreground-400"></i>
              </div>
              <button
                type="button"
                onClick={handleSearch}
                className="px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                搜索
              </button>
            </div>
          </div>

          {searched && (
            <div className="mb-4">
              <span className="text-sm text-foreground-500">
                找到 <strong className="text-foreground-800">{results.length}</strong> 部相关剧集
              </span>
            </div>
          )}

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
            {results.map((drama) => (
              <Link
                key={drama.id}
                to={`/drama/${drama.id}`}
                className="group bg-background-100 border border-background-200 rounded-xl overflow-hidden transition-all duration-300 hover:shadow-md hover:border-primary-200 no-underline"
              >
                <div className="relative w-full aspect-[3/4] overflow-hidden">
                  <img
                    src={drama.image}
                    alt={drama.name}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    onError={(e) => { const t = e.currentTarget; t.style.display = 'none'; }}
                  />
                  <div className="absolute top-2 right-2 px-2 py-1 bg-foreground-950/70 text-background-50 text-xs font-bold rounded-md flex items-center gap-1">
                    <i className="ri-star-fill text-accent-500"></i>
                    {drama.rating}
                  </div>
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors flex items-center justify-center">
                    <span className="px-3 py-1.5 bg-background-50/90 text-foreground-900 text-xs font-medium rounded-full opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
                      查看详情
                    </span>
                  </div>
                </div>
                <div className="p-3">
                  <h3 className="text-sm font-bold text-foreground-900 truncate group-hover:text-primary-500 transition-colors">{drama.name}</h3>
                  <div className="flex items-center gap-1.5 mt-1 flex-wrap">
                    <span className="px-2 py-0.5 bg-accent-100 text-accent-700 text-[10px] font-medium rounded-full whitespace-nowrap">{drama.region}</span>
                    <span className="px-2 py-0.5 bg-secondary-100 text-secondary-700 text-[10px] font-medium rounded-full whitespace-nowrap">{drama.year}</span>
                    <span className="px-2 py-0.5 bg-primary-100 text-primary-700 text-[10px] font-medium rounded-full whitespace-nowrap">{drama.genre}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          {searched && results.length === 0 && (
            <div className="flex flex-col items-center justify-center py-20 text-center">
              <span className="w-16 h-16 flex items-center justify-center bg-background-100 text-foreground-300 rounded-full mb-4 text-3xl">
                <i className="ri-search-line"></i>
              </span>
              <p className="text-sm text-foreground-500">未找到相关剧集，换个关键词试试吧</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}